import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';
import router from './router';
import store from './store';

import i18n from '@/plugins/i18n';
import mouseflow from '@/plugins/mouseflow';
import Constants from '@/plugins/Constants';
import debounce from '@/directives/debounce';

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ProgressSpinner from 'primevue/progressspinner';
import Steps from 'primevue/steps';
import ConfirmationService from 'primevue/confirmationservice';

import Chart from 'primevue/chart';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import Password from 'primevue/password';
import ConfirmDialog from 'primevue/confirmdialog';
import Card from 'primevue/card';

import HTMLParagraphElement1 from '@/components/html/HTMLParagraphElement1';
import HTMLParagraphElement2 from '@/components/html/HTMLParagraphElement2';
import HTMLParagraphElement3 from '@/components/html/HTMLParagraphElement3';
import HTMLParagraphElement4 from '@/components/html/HTMLParagraphElement4';
import HTMLParagraphElement5 from '@/components/html/HTMLParagraphElement5';
import HTMLParagraphElement6 from '@/components/html/HTMLParagraphElement6';

import 'primevue/resources/themes/saga-orange/theme.css'; //theme
import 'primevue/resources/primevue.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import 'primeflex/primeflex.css'; //layout
import '@/assets/styles/base.scss'; //base
import '@/assets/styles/buttons.scss';
import '@/assets/styles/datepicker.scss';
import '@/assets/styles/inputs.scss';
import '@/assets/styles/transactions.scss';
import '@/assets/styles/tabs.scss';
import '@/assets/styles/table.scss';
import '@/assets/styles/hacks.scss';

import '../../../Mouseflow.App.Spa/src/assets/styles/mouseflow_toggle.scss';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status == 401)
            store.dispatch('signOut').then(() => {
                window.Intercom('shutdown');
                router.push({ name: 'SignIn' });
            });
        return Promise.reject(error);
    }
);

createApp(App)
    .use(router)
    .use(store)
    .use(i18n)
    .use(mouseflow)
    .use(PrimeVue)
    .use(ToastService)
    .use(ConfirmationService)
    .use(Constants)

    .component('Chart', Chart)
    .component('InputText', InputText)
    .component('InputSwitch', InputSwitch)
    .component('Checkbox', Checkbox)
    .component('Password', Password)
    .component('Button', Button)
    .component('Steps', Steps)
    .component('ProgressSpinner', ProgressSpinner)
    .component('Card', Card)
    .component('p1', HTMLParagraphElement1)
    .component('p2', HTMLParagraphElement2)
    .component('p3', HTMLParagraphElement3)
    .component('p4', HTMLParagraphElement4)
    .component('p5', HTMLParagraphElement5)
    .component('p6', HTMLParagraphElement6)
    .component('ConfirmDialog', ConfirmDialog)

    .directive('tooltip', Tooltip)
    .directive('debounce', (el, binding) => debounce(el, binding))

    .mount('#app');
